
import Cookies from 'js-cookie'
import { cms_site_info } from '@/api/portal'
import { user_refresh } from '@/api/login'
import { loadSiteRoutes } from '@/router/routes'
import qs from 'qs'
import router from '@/router'
import store from '@/store'
const state = {
  siteId: '', // 站点id
  siteName: '',
  siteInfo: {}, // 站点信息
  nodeMap: {}, // 节点id
  tokenValidTime: 1000 * 20 * 60, // token有效时间
  refreshDiffMs: 0, // 刷新token时间差
  isPro: process.env.NODE_ENV === 'production', // 是否生产环境

  cancelTokens: [],

  Bucket_pub: process.env.VUE_APP_Bucket_pub,
  Bucket_internal: process.env.VUE_APP_Bucket_internal,
  oss_internal_domain: process.env.VUE_APP_oss_internal_domain,
  oss_pub_domain: process.env.VUE_APP_oss_pub_domain,
  static_resource: process.env.VUE_APP_STATIC_SOUCRE,
  transportProtocol: process.env.VUE_APP_transport_protocol,

  isEchartsComplete: false, // echarts文件是否加载完成
  isMapJsComplete: false, // 地图相关文件是否加载完成
  isOssComplete: false // ali-oss文件是否加载完成

}

const mutations = {
  setSiteInfo(state, data) {
    state.siteInfo = data
    this.commit('app/loadChild', { children: data.nodes, rCount: 0 })
  },

  // 设置token过期时间
  setTokenExpTime(state) {
    Cookies.set('tokenExpirTime', new Date().getTime() + state.tokenValidTime)
  },

  loadChild(state, { children, rCount }) {
    rCount++
    for (const i in children) {
      // if (rCount > 2) {
      //   continue
      // }
      state.nodeMap[children[i].code] = children[i].id
      // if (i === children.length - 1) {
      //   rCount--
      // }
      if (children[i].children && children[i].children.length) {
        // if (rCount >= 2) {
        //   this.rCount = 0
        // }
        this.commit('app/loadChild', { children: children[i].children, rCount })
      }
    }
  },

  // 设置站点模板动态路由
  setSiteTemplateRoute(state, templateRoute) {
    loadSiteRoutes(templateRoute,state.siteInfo)
  },
  // 地图js文件加载回调
  mapJsCompleteFn(state, bool) {
    state.isMapJsComplete = bool
  },
  // echarts文件加载回调
  chartsCompleteFn(state, bool) {
    state.isEchartsComplete = bool
  },
  // oss文件加载回调
  ossCompleteFn(state, bool) {
    state.isOssComplete = bool
  },

  // 取消切换路由还没加载完的请求
  cancelRequesting(state) {
    state.cancelTokens.forEach(i => {
      i()
    })
  }

}

const actions = {
  // 初始化站点
  async initSite(store) {
    Cookies.set('domain', location.host)
    const { data: info } = await cms_site_info()
    Cookies.set('siteId', info.siteId)
    store.state.siteId = info.siteId
    store.state.siteName = info.name
    document.title = info.name
    store.commit('setSiteInfo', info)
    store.commit('setSiteTemplateRoute', info.templateRoute)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
